import { GamIntegration, GamNetworkConfig } from '@pubstack/common/src/gam/adx'
import { MutationToasts, useMutation, useQuery } from '../api-client'

export const GAM_INTEGRATION_QUERY_KEYS = ['admin', 'gam-integration']

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useGamIntegration = (scopeId?: string) => {
  return useQuery<GamIntegration>({
    url: `/admin/scopes/${scopeId}/integration/gam`,
    keys: [...GAM_INTEGRATION_QUERY_KEYS, scopeId ?? ''],
    enabled: !!scopeId,
  })
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useCreateServiceAccount = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<{ scopeName: string }>({
    method: 'post',
    url: `/admin/scopes/${scopeId}/integration/gam/service-account`,
    collectionKeys: [...GAM_INTEGRATION_QUERY_KEYS, scopeId],
    ...toasts,
  })
}

export const useLaunchGamChecks = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<{ networkCode: number }, GamNetworkConfig>({
    method: 'post',
    url: `/admin/scopes/${scopeId}/integration/gam/launch-checks`,
    collectionKeys: [...GAM_INTEGRATION_QUERY_KEYS, scopeId],
    ...toasts,
  })
}
